<div class="contact-us-footer">
  @if (isSparePartsEnabled) {
    <div class="parts">
      <p class="parts__title">{{ 'app-footer.contact-parts' | translate }}</p>
      <address>
        @if (address.needHelp?.questionsAboutParts?.phoneNumber) {
          <p class="parts__item" [attr.data-test]="'desc-contactUs-phone'">
            <span class="icon-phone"></span>
            <a href="tel:{{address.needHelp.questionsAboutParts.phoneNumber}}">
              {{ address.needHelp.questionsAboutParts.phoneNumber
                | phoneNumber: (address.phoneNumberFormat ?? '') : (address.delimiter ?? '') : (address.prefix ?? '') }}
            </a>
            {{ address.needHelp.questionsAboutParts.phoneNumberAdditionalInfo }}
          </p>
        }
        @if (address.needHelp?.questionsAboutParts?.directSalesEmailAddress) {
          <p class="parts__item" [attr.data-test]="'desc-contactUs-email'">
            <span class="icon-email"></span>
            <a href="mailto:{{address.needHelp.questionsAboutParts.directSalesEmailAddress}}">
              {{ address.needHelp.questionsAboutParts.directSalesEmailAddress }}
            </a>
          </p>
        }
        @if (address.needHelp?.questionsAboutParts?.partsClarificationEmailAddress) {
          <p class="parts__item">
            <span class="icon-email"></span>
            <a href="mailto:{{address.needHelp.questionsAboutParts.partsClarificationEmailAddress}}">
              {{ address.needHelp.questionsAboutParts.partsClarificationEmailAddress }}
            </a>
          </p>
        }
      </address>
    </div>
  }
  @if (isCpqEnabled) {
    <div class="contracts">
      <p class="contracts__title">{{ 'app-footer.contact-contracts' | translate }}</p>
      @if (address.needHelp?.questionsAboutContracts?.phoneNumber) {
        <p class="contracts__item">
          <span class="icon-phone"></span>
          <a href="tel:{{address.needHelp.questionsAboutContracts.phoneNumber}}">
            {{ address.needHelp.questionsAboutContracts.phoneNumber
              | phoneNumber: (address.phoneNumberFormat ?? '') : (address.delimiter ?? '') : (address.prefix ?? '') }}
          </a>
          {{ address.needHelp.questionsAboutContracts.phoneNumberAdditionalInfo }}
        </p>
      }
      @if (address.needHelp?.questionsAboutContracts?.emailAddress) {
        <p class="contracts__item">
          <span class="icon-email"></span>
          <a href="mailto:{{address.needHelp.questionsAboutContracts.emailAddress}}">
            {{ address.needHelp.questionsAboutContracts.emailAddress }}
          </a>
        </p>
      }
    </div>
  }
  <div class="support">
    <p class="support__title">{{ 'app-footer.contact-support' | translate }}</p>
    @if (address.needHelp?.websiteAndTechnicalSupport?.phoneNumber) {
      <p class="support__item">
        <span class="icon-phone"></span>
        <a href="tel:{{address.needHelp.websiteAndTechnicalSupport.phoneNumber}}">
          {{ address.needHelp.websiteAndTechnicalSupport.phoneNumber
            | phoneNumber: (address.phoneNumberFormat ?? '') : (address.delimiter ?? '') : (address.prefix ?? '') }}
        </a>
        {{ address.needHelp.websiteAndTechnicalSupport.phoneNumberAdditionalInfo }}
      </p>
    }
    @if (address.needHelp?.websiteAndTechnicalSupport?.emailAddress) {
      <p class="support__item" [attr.data-test]="'desc-support-email'">
        <span class="icon-email"></span>
        <a href="mailto:{{address.needHelp.websiteAndTechnicalSupport.emailAddress}}">
          {{ address.needHelp.websiteAndTechnicalSupport.emailAddress }}
        </a>
      </p>
    }
  </div>
</div>
